import { type CSSProperties } from "react";
import { useNavigate } from "react-router";
import { InheritanceChip } from "../primitives";
import type { LibraryNodeDetail } from "../../../lib/types";

interface InheritanceStripProps {
  node: LibraryNodeDetail;
}

export function InheritanceStrip({ node }: InheritanceStripProps) {
  const navigate = useNavigate();
  const ancestors = node._breadcrumb ?? [];

  if (ancestors.length === 0) return null;

  const strip: CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    padding: "8px 0",
  };

  return (
    <div style={strip}>
      {ancestors.map((ancestor) => {
        const instructionCount = 1;
        return (
          <InheritanceChip
            key={ancestor.id}
            scopeLabel={ancestor.name}
            itemCount={instructionCount}
            onClick={() => navigate(`/agents/${ancestor.id}`)}
          />
        );
      })}
    </div>
  );
}
